import { api } from './api';

export const getTestimonials = () => api.get('/api/testimonials');
